import { useZonedDateTime } from "../../../../../../../../components/global_components/ZonedDateTime";
import { GetNotifyNotificationContentSearchResponse } from "../../../../../../../../queries/notify";
import { formatDateFromNow } from "../../../../../../../../utils/functions";

export function NotifyNotificationsDates({
  content,
}: {
  content: GetNotifyNotificationContentSearchResponse["data"][number];
}) {
  const formattedPublishedAt = useZonedDateTime({
    value: content.publishedAt,
    formatString: "MMM d, yyyy",
    disableAutoTimezoneIndicator: true,
  });
  const formattedArchivedAt = useZonedDateTime({
    // Technically not the same as an "archivedAt" field, but should be pretty close and I can't be bothered to add a new field just for this
    value: content.archiveAt,
    formatString: "MMM d, yyyy",
    disableAutoTimezoneIndicator: true,
  });

  const dateString = [
    content.status === "Draft" ? `Last edited ${formatDateFromNow(content.updatedAt)}` : null,
    formattedPublishedAt ? `Sent ${formattedPublishedAt}` : null,
    formattedArchivedAt ? `Expires ${formattedArchivedAt}` : null,
  ]
    .filter(Boolean) // Remove null values
    .join(" • ");

  return <span className='tw-font-semibold tw-text-text-hint'>{dateString}</span>;
}
